<div class="file-upload">
	<ng-container *ngIf="!isReadOnly">
		<button *ngIf="buttonType === 'stroked'" type="button" mat-stroked-button color="primary" aria-label="Pick a file to upload"
			(click)="openFileBrowser()">
			<mat-icon>cloud_upload</mat-icon>
			{{ buttonText }}
		</button>
		<button *ngIf="buttonType === 'icon'" type="button" mat-icon-button color="primary" aria-label="Pick a file to upload"
			(click)="openFileBrowser()">
			<mat-icon>cloud_upload</mat-icon>
			{{ buttonText }}
		</button>
		<button type="button" mat-stroked-button color="warn" aria-label="Remove Image" (click)="removeFile()"
			*ngIf="isImage && (uploadedFile$|async).fileBase64Encoded" style="margin-left: 8px;">
			<mat-icon>close</mat-icon>
			Remove
		</button>
		<input style="display: none;" type="file" accept="{{ allowedExtensions.join(',') }}" (change)="fileChangeEvent($event)" #fileUploadInput />
		<div class="clear"></div>
	</ng-container>
	<ng-container *ngIf="(uploadedFile$|async) as file">
		<img [src]="'data:image/jpeg;base64,' + file.fileBase64Encoded" class="img-responsive preview" *ngIf="file.fileBase64Encoded && isImage"
			alt="Image Preview" />
		<div class="file-name-position" *ngIf="!hideFileName && file.fileName && !isImage">
			<!--We should really be storing the entire Base64 in the database rather than only storing what comes after base64, image/jpeg seems to work regardles of what the file type actually is-->
			<a class="file-name-overflow" [download]="file.fileName" [href]="'data:image/jpeg;base64,' + file.fileBase64Encoded" title="Download File"
				*ngIf="!readAsText">{{
				file.fileName }}</a>
			<span class="file-name-overflow" *ngIf=" readAsText">{{ file.fileName }}</span>
			<button type="button" mat-icon-button matSuffix title="Remove File" (click)="removeFile()" *ngIf="!isReadOnly">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</ng-container>
</div>